var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('multiselect',{attrs:{"panelName":"encounter_referral","panelType":"select","languagePath":"locations","sortAlphabetical":true,"onClick":_vm.set},model:{value:(_vm.referrals),callback:function ($$v) {_vm.referrals=$$v},expression:"referrals"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }